<template>
  <div class="search-options">
    <div class="search-options__left-col">
      <h3 class="search-options__section-title">{{$tFilter('Field of activity')}}</h3>
      <SFilterDirection :value="direction"
                        @input="onDirectionInput"
                        :cancelable="false"
                        preload/>
      <div class="search-options__professions-container">
        <OverlayScrollbarsComponent class="search-options__professions-list-scrollbar">
          <div class="search-options__professions-list-wrap">
            <BasePreloader v-if="pendingCategories"/>
            <div class="search-options__checkbox-list">
              <BaseCheckbox v-for="category in categoriesList"
                            :key="category.id"
                            :label="category.category.title"
                            v-model="category.selected"
                            @input="onInput"
                            class="search-options__checkbox  _white"/>
            </div>
          </div>
        </OverlayScrollbarsComponent>
      </div>
    </div>
    <div v-if="pendingFilters" class="search-options__right-col">
      <BasePreloader/>
    </div>
    <div v-else class="search-options__right-col">
      <div class="search-options__section">
        <h3 class="search-options__section-title">{{$tFilter('Popular filters')}}</h3>
        <BaseRadioList v-model="topFiltersSelected"
                       :options="topFilters"
                       textKey="nicename"
                       :all="$tFilter('No selected')"
                       @input="onInput"
                       class="_vertical"/>
      </div>
      <!--      <div class="search-options__section">-->
      <!--        <h3 class="search-options__section-title">{{$tFilter('Housing')}}</h3>-->
      <!--        <BaseRadioList v-model="housing_type"-->
      <!--                       :options="filterStaticParams.housing"-->
      <!--                       textKey="name"-->
      <!--                       :all="$tFilter('All')"-->
      <!--                       @input="onInput"-->
      <!--                       class="_vertical"/>-->
      <!--      </div>-->
      <!--      <div class="search-options__section">-->
      <!--        <h3 class="search-options__section-title">{{$tFilter('Schedule')}}</h3>-->
      <!--        <BaseRadioList v-model="schedule_type"-->
      <!--                       :options="filterStaticParams.schedule"-->
      <!--                       textKey="name"-->
      <!--                       :all="$tFilter('All')"-->
      <!--                       @input="onInput"-->
      <!--                       class="_vertical"/>-->
      <!--      </div>-->
      <div class="search-options__section">
        <h3 class="search-options__section-title">{{$tFilter('Salary')}}
          <span class="search-options__section-title-note">({{currentCurrency.currency}}/{{$tFilter('mon')}})</span>
        </h3>
        <div class="search-options__slider-wrap">
          <VueSlider :value="salaryComputed"
                     :min="salaryMin"
                     :max="salaryMax"
                     :enableCross="false"
                     :dotSize="['22', '22']"
                     height="0.8rem"
                     tooltip="none"
                     :contained="true"
                     @change="onSalarySliderInput"
                     class="search-options__slider"/>
        </div>
        <div class="search-options__range-inputs">
          <div class="search-options__range-input-wrap">
            <div class="search-options__range-input-name">{{$tFilter('from')}}</div>
            <BaseInput :value="salaryComputed[0]"
                       :leftSpace="getSpaceByText($tFilter('from'))"
                       @change="onSalaryFromInput"
                       class="search-options__range-input"/>
          </div>
          <div class="search-options__range-inputs-separator">-</div>
          <div class="search-options__range-input-wrap">
            <div class="search-options__range-input-name">{{$tFilter('to')}}</div>
            <BaseInput :value="salaryComputed[1]"
                       :leftSpace="getSpaceByText($tFilter('to'))"
                       @change="onSalaryToInput"
                       class="search-options__range-input"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import {http} from '../axios'
  import 'overlayscrollbars/css/OverlayScrollbars.css'
  import {OverlayScrollbarsComponent} from 'overlayscrollbars-vue';

  import VueSlider from 'vue-slider-component'
  import 'vue-slider-component/theme/default.css'

  import SFilterDirection from './loadingSelects/SFilterDirection'

  export default {
    components: {
      OverlayScrollbarsComponent,
      VueSlider,
      SFilterDirection,
    },
    props: {
      canLoad: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        pendingCategories: false,
        categoriesList: [],

        direction: null,
        housing_type: null,
        schedule_type: null,
        salary: [],
        topFiltersSelected: null
        //
        // salaryRange: {
        //   from: null,
        //   to: null
        // },
        // salaryType: [],
        // housingList: [],
        // scheduleList: [],
      }
    },
    computed: {
      ...mapState('filter', [
        'pendingFilters',
        'directionsList',
        'filterStaticParams'
      ]),
      currentCurrency() {
        return this.$store.state.currentCurrency
      },
      salaryMin() {
        return this.filterStaticParams.salary && this.filterStaticParams.salary.min || 1
      },
      salaryMax() {
        return this.filterStaticParams.salary && this.filterStaticParams.salary.max || 2
      },
      salaryComputed() {
        return [
          this.salary[0] || this.salaryMin,
          this.salary[1] || this.salaryMax,
        ]
      },
      topFilters() {
        return this.$store.state.filter.topFilters
      }
    },
    methods: {
      reset() {
        this.pendingCategories = false
        this.categoriesList = []
        this.direction = null
        this.housing_type = null
        this.schedule_type = null
        this.salary = []
      },
      getSearchParams() {
        const filters = {}
        const dynamic = {}

        if (this.topFiltersSelected) {
          this.topFiltersSelected.route.params.filters.forEach(filter => {
            const r = filter.split('-')
            if (r.length < 2) return

            filters[r[0]] = r[1]
          })

          this.topFiltersSelected.route.params.dynamic.forEach(filter => {
            const r = filter.split('-')
            if (r.length < 2) return

            dynamic[r[0]] = r[1].split('|')
          })
        }

        if (this.salary[0] && this.salary[0] !== this.salaryMin) {
          filters.salary_from = this.salary[0]
        }

        if (this.salary[1] && this.salary[1] !== this.salaryMax) {
          filters.salary_to = this.salary[1]
        }

        if (this.housing_type) {
          filters.housing_type = this.housing_type.id
        }

        if (this.schedule_type) {
          filters.schedule_type = this.schedule_type.id
        }

        return {
          filters,
          dynamic
        }
      },
      onInput() {
        const categories = this.categoriesList
            .reduce((arr, item) => {
              if (item.selected) arr.push(item.category.slug)
              return arr
            }, [])

        const params = this.getSearchParams()

        this.$emit('input', {
          direction: this.direction ? this.direction.slug : null,
          categories,
          filters: params.filters,
          dynamic: params.dynamic
        })
      },
      // load() {
      //   http.get('/api/vacancies/filters').then(({data}) => {
      //     debugger
      //     console.log(data)
      //   })
      // },
      onDirectionInput(direction) {
        this.direction = direction || null

        this.loadCategories()
        this.onInput()
      },
      loadCategories() {
        this.categoriesList = []

        this.pendingCategories = true

        return http.get(`/api/vacancies/categories-list-all`, {
          params: {
            direction_id: this.direction ? this.direction.id : null,
            only_with_vacancies: 1
          }
        }).then(({data}) => {
          this.categoriesList = data.data
        }).finally(() => {
          this.pendingCategories = false
        })
      },
      onSalarySliderInput(value) {
        this.salary = value
        this.onInput()
      },
      onSalaryFromInput(value) {
        value = parseFloat(value) || 0
        if (value > this.salary[1]) value = this.salary[1] - 1
        if (value < this.salaryRange.min) value = this.salaryRange.min

        this.$set(this.salary, 0, value)
        this.onInput()
      },
      onSalaryToInput(value) {
        value = parseFloat(value) || 0
        if (value < this.salary[0]) value = this.salary[0] + 1
        if (value > this.salaryRange.max) value = this.salaryRange.max

        this.$set(this.salary, 1, value)
        this.onInput()
      },
      // preLoad() {
      //   this.pendingCategories = true
      //
      //   http.get(`/api/vacancies/categories-list-all`).then(({data}) => {
      //     this.categoriesList = data.data
      //   }).finally(() => {
      //     this.pendingCategories = false
      //   })
      // },

      getSpaceByText(text) {
        if (typeof text !== 'string') return
        return text.length * 0.7
      },
      // onTopFilter(route) {
      //
      // }
    },
    created() {
      if (this.canLoad) {
        this.$store.dispatch('filter/loadFilters')
      }
      this.loadCategories()
      // this.preLoad()
    },
    watch: {
      canLoad() {
        if (this.canLoad) {
          this.$store.dispatch('filter/loadFilters')
        }
      }
    }
  }

  // function shouldLoadCategories(category, direction) {
  //   if (!category || !category.category || !category.category.direction_id) return false
  //
  //   if (!direction) return true
  //   return direction.id !== category.category.direction_id
  // }
</script>

<style lang="less">

</style>
